module.exports = __webpack_public_path__ + "img/failed.b1d34a48.png";